import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TabElement } from './models';

@Component({
	selector: 'app-tabs',
	templateUrl: './tabs.component.html',
	styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit {
	@Input() public tabElements: TabElement[];
	@Output() public selectedTabUpdated: EventEmitter<string> = new EventEmitter();
	public defaultTabSelectedKey: string;

	public ngOnInit() {
		this.defaultTabSelectedKey = this.tabElements ? this.tabElements[0].key : '';
	}

	public handleSegmentChanged(e: any): void {
		this.tabElements = this.tabElements.map((tabEl: TabElement) => {
			let isSelected = false;

			if (tabEl.key === e.detail.value) {
				isSelected = true;
			}

			return {
				...tabEl,
				isSelected
			};
		});

		this.selectedTabUpdated.emit(e.detail.value);
	}
}
